import Backbone from 'backbone';
import Block from './Block';

export default Backbone.Collection.extend({
  model: Block
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/block_manager/model/Blocks.js